import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './NotificationsBadge.m.sass';
var NotificationsBadge = function NotificationsBadge(_ref) {
  var count = _ref.count,
    _ref$top = _ref.top,
    top = _ref$top === void 0 ? -9 : _ref$top,
    _ref$right = _ref.right,
    right = _ref$right === void 0 ? 7 : _ref$right;
  var str = count > 99 ? '99+' : count.toString();
  return /*#__PURE__*/React.createElement("div", {
    style: {
      top: top,
      right: right
    },
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.count, styles["s".concat(str.length)], count > 0 && styles.showing)
  }, str));
};
export default observer(NotificationsBadge);
//# sourceMappingURL=index.js.map
